import { Activity, RefreshCw } from "lucide-react";
import { usePlcBenchWorkspace } from "./technical/usePlcBenchWorkspace";
import "./plc-bench.css";

export function PlcBenchPage() {
const { reading, error, changedAt, refresh } = usePlcBenchWorkspace();
const connected = reading?.status === "GOOD";
const time = reading?.measuredAt ? new Date(reading.measuredAt).toLocaleTimeString("tr-TR") : "—";
return <main className="plc-bench">
    <div className="plc-bench-panel">
      <header className="plc-bench-header">
        <div className="plc-bench-heading"><Activity aria-hidden="true" size={28} /><div><h1>PLC tezgâhı</h1><p>Salt okunur bağlantı kontrolü · üretim kaydı oluşturmaz</p></div></div>
        <button type="button" onClick={() => void refresh()}><RefreshCw aria-hidden="true" size={18} /> Yeniden oku</button>
      </header>
      <section className="plc-bench-content" aria-live="polite">
        <div className={`plc-bench-status ${connected ? "is-good" : "is-bad"}`}><span className="plc-bench-dot" />{connected ? "PLC okunuyor" : reading?.status === "DISABLED" ? "Ekran kapalı" : error || reading ? "PLC okunamıyor" : "Bağlanıyor"}</div>
        <p className="plc-bench-label">D100–D101 · 32 bit sayaç</p>
        <strong className="plc-bench-value">{connected && reading.value !== null ? new Intl.NumberFormat("tr-TR").format(reading.value) : "—"}</strong>
        <div className="plc-bench-meta"><span>Son okuma: <strong>{time}</strong></span><span>Son değişim: <strong>{changedAt ? new Date(changedAt).toLocaleTimeString("tr-TR") : "Henüz gözlenmedi"}</strong></span></div>
        {!connected && <p className="plc-bench-error">{error || "Bağlantıyı ve yerel PLC ayarlarını kontrol edin. Ekran otomatik tekrar dener."}</p>}
      </section>
    </div>
  </main>;
}
